angular.module('ui2.0Directives').directive('cdrAnalyticStats', ['$http', '$q', '$rootScope', '$timeout', function (http, $q, rootScope, timeout) {
    return {
        restrict: 'A',
        scope: true,
        templateUrl: rootScope.createHtmlUrl("ui2.0/directiveTemplates/analyticStats.html"),
        link: function (scope, element, attrs) {
            var reviewAnalyticsTab = {
                'id': 5,
                'activate': false
            };
            // Map color for all analytic tabs based on ID @param
            function analyticsStatsColorMapper(id) {
                switch (id) {
                    case 1:
                        return 'yellow';
                    case 2:
                        return 'blue';
                    case 3:
                        return 'red';
                    case 5:
                        return 'purple';
                    case 6:
                        return 'purple';
                }
            }
            scope.showVerCompareTypeDD = false;
            scope.showCategoryDD = false;
            scope.showActivityDD = false;

            scope.blockFilterReset = false;
            
            scope.mapFilterTextClr = {
                "1": 'yellow',
                "2": 'blue',
                "3": 'red',
                "7": 'red',
                "8": 'yellow',
                "9": 'grey'
            }
            

            // Get analyTicStats
            scope.loadAnalytics = ({deviationStatus, notInitRequest} = {}) => {
                reviewAnalyticsTab.activate = false;
                scope.blockFilterReset = false;
                const tStamp = new Date().getTime();
                const dataToPost = {
                    "deviationStatusList": [],
                    "categoryType": [],
                    "deviationSeverityStatus": [],
                    "reviewStatus": []
                };
                let url = scope.appBaseApiUrl + '/tblcdr/deviationSummary/v2/' + scope.data.entityTypeId.values + '/' + scope.data.id.values;
                if (angular.isDefined(attrs.docfileid))
                    url += '?documentFileId=' + attrs.docfileid;
                if(scope.deviationReference?.id) {
                    url += (url.includes('?') ? '&' : '?')+'deviationReference='+scope.deviationReference.id;
                }
                url = SirionUtils.addQueryString(url, "_t="+ tStamp);

                if ($('#noCDRDataToShow').length > 0) {
                    $('#noCDRDataToShow').remove();
                }
                return http.post(url, dataToPost).then(function (response) {
                    scope.isDeviationCompleted = response.data.deviationCompleted;
                    let deviationFailed = response.data.deviationFailed;
                    let analyticsStatsData = response.data.deviationSummaries;
                    let totalActivityCount = 0, totalCategoryCount = 0, totalDeviationPriorityCount = 0;
                    if (deviationFailed) {
                        Toaster.create(intl_msg[47753] || 'Clause analysis could not be completed for this document. Please contact your system administrator for assistance', {iconClass: "icon-Information_filled"});
                    }
                    if (!scope.isDeviationCompleted) {
                        // Show loader
                        let errorMsg = intl_msg[29874] || 'We are analysing the clauses in the document.. Please wait.';
                        let noDataHtml = "<div id='noCDRDataToShow' class='noTemplate'><div class=\"noDataToDisplay\"><div class=\"no-data-image\">  <video style='height: 160px;' id=\"docViewerNoData\"   muted=\"true\" preload=\"auto\" autoplay loop><source src=\"src/images/mp4/doc-viewer.mp4\"  type=\"video/mp4\"></video><span class=\"no-data-text\">" + errorMsg + "</span></div></div>";
                        $('.analytic-detailed-view .clause-deviation-view > div').hide();
                        $('.analytic-detailed-view .clause-deviation-view').append(noDataHtml);
                        stopLoader();
                        return;
                    } else {
                        $('.analytic-detailed-view .clause-deviation-view > div').show();
                    }
                    angular.forEach(analyticsStatsData, function (e, i) {
                        e['color'] = analyticsStatsColorMapper(e.id);
                        if(e.group == 1){
                            totalActivityCount += e.count;
                        }
                        else if(e.group == 4) {
                            totalCategoryCount += e.count;
                        }
                        else if(e.group == 3) {
                            totalDeviationPriorityCount += e.count;
                        }
                        else if(e.id == 5 && e.totalCount > 0) {
                            reviewAnalyticsTab.activate = !notInitRequest;
                        }
                    });
                    scope.deviationReference = response.data.deviationReference;
                    scope.initAnalyticsDirective(analyticsStatsData, totalActivityCount, scope.cardDeviationStatus, response.data.deviationReferences, totalCategoryCount, totalDeviationPriorityCount, notInitRequest);
                }, function errorCallback(error) {
                    console.error('Data cannot be loaded due to: ' + error);
                });
            }

            scope.setFilterAndRenderList = (e, keyInScope, selectedObj) => {
                if(selectedObj?.id == _.get(scope, keyInScope)?.id) return;
                scope.analyticsStatsData.selectedActivity = null;
                scope.analyticsStatsData.selectedCategory = null;
                scope.analyticsStatsData.selectedDeviationPriority = null;
                scope.analyticsStatsData.selectedReviewStatus = null;
                reviewAnalyticsTab.activate = false;
                _.set(scope, keyInScope, selectedObj);
                const detailedListElemArr = document.getElementsByClassName('clause-deviation-table');
                if(detailedListElemArr && detailedListElemArr.length) {
                    detailedListElemArr[0].scrollTop = 0;
                }
                startLoader();
                scope.visibleColumns?.forEach(visibleColumn => {visibleColumn['isAsc'] = false; visibleColumn['isDsc'] = false;});
                keyInScope.includes('analyticsStatsData') && !keyInScope.includes('selectedReviewStatus') ? scope.initClauseTable(selectedObj && selectedObj.id) : scope.loadAnalytics({notInitRequest: true});
            }

            scope.$watch(function () {
                return element.attr("data-docfileid");
            }, function (newValue) {
                if(!newValue){
                    return;
                }
                timeout(function () {
                    scope.loadAnalytics({notInitRequest: scope.blockFilterReset});
                }, 10);
            });

            // Initialize analytics directive
            scope.initAnalyticsDirective = (analyticsStatsData, totalActivityCount, cardDeviationStatus, versionComparisonTypes, totalCategoryCount, totalDeviationPriorityCount, notInitRequest) => {
                // scope.analyticsStatsData = analyticsStatsData;
                scope.analyticsStatsData = {
                    ...(!notInitRequest ? {
                        'selectedActivity': null,
                        'selectedCategory': null,
                        'selectedDeviationPriority': null,
                        'selectedReviewStatus': null
                    } : scope.analyticsStatsData),
                    'data': analyticsStatsData,
                    'categories': (analyticsStatsData?.filter(statData => statData?.group == 4 && (statData.count > 0)) || []),
                    'deviationPriorities': (analyticsStatsData?.filter(statData => statData?.group == 3 && statData.count > 0) || []),
                    'activities': (analyticsStatsData?.filter(statData => statData?.group == 1 && statData.count > 0) || []),
                    'reviewPendings': (analyticsStatsData?.filter(statData => statData?.group == 2 && statData.totalCount > 0) || []),
                    'versionComparisonTypes': versionComparisonTypes,
                    'totalActivityCount': totalActivityCount,
                    'totalCategoryCount': totalCategoryCount,
                    'totalDeviationPriorityCount': totalDeviationPriorityCount
                };
                if(scope.fromCardDeviation && cardDeviationStatus && analyticsStatsData) {
                    if([1,2,3,14].includes(cardDeviationStatus)) {
                        scope.analyticsStatsData.selectedActivity = analyticsStatsData.find(analyticStats => _.get(analyticStats, 'id') == cardDeviationStatus);
                    } else if(cardDeviationStatus > 6 && cardDeviationStatus < 10) {
                        scope.analyticsStatsData.selectedDeviationPriority = analyticsStatsData.find(analyticStats => _.get(analyticStats, 'id') == cardDeviationStatus);
                    } else if([5,6].includes(cardDeviationStatus)) {
                        scope.analyticsStatsData.selectedReviewStatus = analyticsStatsData.find(analyticStats => _.get(analyticStats, 'id') == cardDeviationStatus);
                    }
                } else if(reviewAnalyticsTab.activate && reviewAnalyticsTab.id) {
                    scope.analyticsStatsData.selectedReviewStatus = analyticsStatsData.find(analyticStats => _.get(analyticStats, 'id') == 5);
                }
                scope.activeAnalyticsId = null;
                if(reviewAnalyticsTab.activate && reviewAnalyticsTab.id){
                    scope.activeAnalyticsId = reviewAnalyticsTab.activate && reviewAnalyticsTab.id;
                }

                timeout(function () {
                    if(scope.fromCardDeviation){
                        scope.initClauseTable(cardDeviationStatus);
                        scope.activeAnalyticsId = cardDeviationStatus;
                        scope.fromCardDeviation = false;
                    }else{
                        scope.initClauseTable(reviewAnalyticsTab.activate && reviewAnalyticsTab.id);
                    }
                }, 100);
            }

            scope.setActiveState = (e, link) => {
                const currentAnalyTicElem = angular.element(e.currentTarget);
                if (!currentAnalyTicElem.hasClass('isClickable')) {
                    return;
                }
                startLoader();
                if (currentAnalyTicElem.attr('activeAnalyticsId') == scope.activeAnalyticsId) {
                    scope.activeAnalyticsId = null;
                    // return;
                } else {
                    scope.activeAnalyticsId = parseInt(currentAnalyTicElem.attr('activeAnalyticsId'));
                }
                scope.initClauseTable(scope.activeAnalyticsId);
            }

            scope.$on('contractCardFiltering', async (event, deviationStatus, documentFileIds) => {
                scope.deviationReference = null;
                reviewAnalyticsTab.activate = false;
                if(scope.analyticsStatsData) {
                    scope.analyticsStatsData = {...scope.analyticsStatsData, ...{
                        'selectedActivity': null,
                        'selectedCategory': null,
                        'selectedDeviationPriority': null,
                        'selectedReviewStatus': null
                    }};
                }
                if(deviationStatus) {
                    startLoader();
                    scope.reInitScopeVar();
                    scope.fromCardDeviation = true;
                    scope.cardDeviationStatus = deviationStatus;
                }
                let sortedDocumentFileIds = [];
                if(deviationStatus == 5){
                    reviewAnalyticsTab.activate = true;
                }
                let analyticsLoaded = false;
                    scope.finalListData.forEach(async (item) => {
                        if (documentFileIds.includes(Number(item.documentname.fileId))) {
                            sortedDocumentFileIds.push(item);
                            if ((scope.docFileSelectedId == sortedDocumentFileIds[0].documentname.fileId && _.get(Object.keys(scope.analyticsStatsData), 'length'))) {
                                if(!analyticsLoaded) {
                                    analyticsLoaded = true;
                                    await scope.loadAnalytics({deviationStatus: deviationStatus});
                                    timeout(function () {
                                        scope.activeAnalyticsId = deviationStatus;
                                    }, 500);
                                }
                                return;  
                            } else {
                                let elem = document.getElementById('docId_' + sortedDocumentFileIds[0].documentname.fileId);
                                scope.blockFilterReset = true;
                                $(elem).click();
                            }
                        }
                    })
            })
        }
    }
}]);

angular.module('ui2.0Directives').directive('cdrAnalyticsDetailedView', ['entityFactory', '$http', '$rootScope', 'cdrDataTransformService', '$uibModal', '$q', '$timeout', 'listService', 'showPage2DataTransformationService', '$sce', function (entityFactory, http, rootScope, cdrDataTransformService, $modal, $q, timeout, listService, showPage2DataTransformationService, sce) {
    return {
        restrict: 'AE',
        templateUrl: rootScope.createHtmlUrl("ui2.0/directiveTemplates/analyticsDetailedView.html"),
        link: function (scope, element, attrs) {
            scope.activeListItemIndex = 0;
            scope.finalListData = [];
            scope.docFileSelectedId = null;
            scope.isEmptyAnalyTicsTableData = false;
            scope.isNoDataToShow = false;
            scope.canLoadMoreClauses = true;
            scope.showAnalytics = false;
            scope.viewCompareEdit=false;
            scope.metaData;
            scope.clauseVersion;
            scope.reviewTaskDetail;
            scope.isChildRow = false;
            scope.cardDeviationStatus = null;
            scope.fromCardDeviation = false;
            scope.updatedData = []
            let isFirstRequest = true, retainSortCol = {};
            scope.revertedVersion = {};
            let hasValidationError = false, promise;
            let apiList = ['defaultUserListMetaData', 'listdata'];
            let tabData = attrs.tabField && scope.$eval(attrs.tabField);
            const fieldObj = tabData[0].fields[0];
            const layoutUrl = fieldObj.layoutURL;
            const dataUrl = fieldObj.dataURL;
            const listReqArr = [layoutUrl, dataUrl];
            let postObjForListData = cdrDataTransformService.getPostObjForListData(scope.data.entityTypeId.values);
            initDirective(postObjForListData);
            scope.draftDocumentStatus = {};

            // Reinitialize all the variables
            scope.reInitScopeVar = function () {
                scope.isEmptyAnalyTicsTableData = false;
                scope.isExtTypePDF = false;
                scope.canLoadMoreClauses = true;
                scope.showAnalytics = false;
                scope.clauseCategoryId = null;
                scope.groupId = null;
                scope.offset = 0;
                $('.analytic-detailed-view tr.itemContainer').removeClass('isExpandedView');
                scope.setSortCol();
                scope.page = {
                    'number': 1,
                    'offset': 0,
                    'size': window.innerHeight >= 992 ? 30 : 20
                }
            }

            scope.setSortCol = function(name,dir) {
                scope.sortCol = {
                    'name': name || 'sortOrder',
                    'order': dir || 'asc'
                }
            }

            // Add channel to listen to for broadcasts
            window.sarc.channelInstall('clauseReconcillation');

            function initDirective(postObjForListData) {

                $q.all(listReqArr.map(function (reqUrl) {
                    const apiUrl = ((listReqArr[0] == reqUrl) ? reqUrl + "?entityTypeId=" + scope.data.entityTypeId.values : reqUrl + "?version=2.0");
                    return http({
                        method: 'POST',
                        url: apiUrl,
                        data: (listReqArr[0] == reqUrl) ? {} : JSON.stringify(postObjForListData)
                    });
                })).then(function (results) {
                    let data = {};
                    results.forEach(function (val, i) {
                        data[apiList[i]] = val.data;
                    });
                    scope.metaData = data.defaultUserListMetaData;
                    initLayout(data);
                }, function errorCallback(error) {
                    console.error('Data cannot be loaded due to: ' + error);
                });
            }

            // Sort ListData wrt document versions
            function sortListData(listData) {
                if (!scope.queryNameToIdMapForColumns)
                    listService.createQueryNameToIdMapForColumns.call(scope);
                return listService.sortDocumentVersioningData(listData, scope);
            }

            // Initialize layout for clause review tab
            function initLayout(args) {
                if (angular.isDefined(args)) {
                    const origMetaData = args.defaultUserListMetaData;

                    let finalListData = [],
                        listData = sortListData(args.listdata);

                    if (angular.isDefined(listData) && angular.isDefined(origMetaData)) {
                        if (!SirionUtils.isEmpty(listData)) {
                            for (let i = 0; i < listData.length; i++) {
                                finalListData[i] = {
                                    'originalrowdata': listData[i],
                                    'downloadBtn': SirionUtils.addDownloadDocOptions(listData[i], origMetaData)
                                };
                            }
                        } else {
                            // Show no data cartoon and return;
                            scope.isNoDataToShow = true;
                            stopLoader();
                            return;
                        }

                        const visColToIdMapper = {},
                            visibleColsArray = ["docversionhidden", "version", "documentname", "documentstatus"],
                            visCols = origMetaData.columns.filter(col => {
                                return visibleColsArray.indexOf(col.queryName) > -1;
                            }),
                            visColsCount = visCols.length;

                        // If visible columns, map queryName with id
                        if (visCols) {
                            visCols.forEach(function (col) {
                                visColToIdMapper[col.queryName] = col.id;
                            });
                        }

                        // Go through each visible column from origMetaData
                        for (let i = 0; i < visColsCount; i++) {
                            let k = i,
                                id = visCols[i].id,
                                formatter = $.parseJSON(visCols[i].displayFormat);

                            // Iterate over each row
                            if (!SirionUtils.isEmpty(listData)) {
                                for (let j = 0; j < listData.length; j++) {
                                    if (listData[j][id] != undefined) {
                                        let val = "";
                                        if (formatter.hideColumn && visCols[i].queryName == "docversionhidden") {
                                            let splitParams = listData[j][id].value.split(":;"),
                                                document = {
                                                    'docId': parseInt(splitParams[0]),
                                                    'isParent': splitParams[2],
                                                    'order': parseInt(splitParams[1]),
                                                    'total': parseInt(splitParams[3])
                                                }
                                            val = document;
                                        }
                                        if (formatter != null && formatter.type != undefined) {
                                            let formatType = formatter.type
                                            if (visCols[i].type == "ATTACHMENT") {
                                                val = transformDocName(listData[j][id]);
                                            }
                                            else if (formatType == "docVersion") {
                                                val = listData[j][id].value;
                                            }
                                            else if (formatType == "documentStatus" || formatter.displayType == "dropdown") {
                                                var dropdownData;
                                                if (origMetaData.draftMetadata && origMetaData.draftMetadata.templateTypeList) {
                                                    dropdownData = origMetaData.draftMetadata.templateTypeList;
                                                    formatter.readOnly = true;
                                                }
                                                val = entityFactory.transform.customDropdown(listData[j][id].value, formatter, this, origMetaData.id, dropdownData);
                                            }
                                        }
                                        finalListData[j][visCols[i].queryName] = val;
                                    }
                                }
                            }
                        }
                        transformFinalListData(finalListData);
                    }
                }
            }

            // Transform document name
            function transformDocName(colName) {
                let splitParams = colName.value.split(':;'),
                    link = appName + "/download/communicationdocument?id=" + splitParams[0] + "&entityTypeId=78&entityType.id=" + splitParams[3] + "&fileId=" + splitParams[4],
                    document = {
                        'name': splitParams[1],
                        'link': link,
                        'format': splitParams[2],
                        'fileId': splitParams[4]
                    };
                return document;
            }

            // Transform final list data for left side view
            function transformFinalListData(finalListData) {
                var finalData = [];
                let currentGroupId = null,
                    groupCtr = 0,
                    childCtr = 0;
                for (let i = 0; i < finalListData.length; i++) {
                    let currentRow = finalListData[i];

                    if (currentRow.docversionhidden.isParent == 'true') {
                        finalData[groupCtr] = currentRow;
                        if (currentGroupId !== currentRow.docversionhidden.docId ) {
                            groupCtr++;
                            if(currentRow.docversionhidden.total >1){
                                childCtr = 0;
                            }
                        }
                        currentGroupId = currentRow.docversionhidden.docId;
                    } else {
                        if (currentGroupId == currentRow.docversionhidden.docId) {
                            if (!finalData[groupCtr-1]['childRowData']) {
                                finalData[groupCtr-1]['childRowData'] = [];
                            }
                            finalData[groupCtr-1]['childRowData'][childCtr] = currentRow;
                            childCtr++;
                            // if (currentRow.docversionhidden.order == 0) {
                            //     groupCtr++;
                            //     childCtr = 0;
                            // }
                        }
                    }
                }

                scope.finalListData = finalData;
                const docColData = finalData[0]['originalrowdata'];
                scope.draftDocumentStatus['isDocumentDraftModeEnable'] = SirionUtils.iterateTableData(docColData, "document_draft_mode");
                scope.draftDocumentStatus['isDocLocked']  = SirionUtils.iterateTableData(docColData, "locked_status");
                scope.draftDocumentStatus['isDocLockedWithValue'] = scope.draftDocumentStatus['isDocLocked'] === "true:;10";
                scope.selectedDocId = scope.finalListData[0]['docversionhidden'].docId;
                updateDocFileId(scope.finalListData[0]['documentname']);
            }

            // Update DocFileId and reset all the scope variables to initial state before triggering analytics directive watch cycle
            function updateDocFileId(docProp) {
                scope.docFileSelectedId = docProp && docProp.fileId || null;
                scope.docFileSelectedFormat = docProp && docProp.format || null;
                scope.reInitScopeVar();
                if (!scope.$$phase) {
                    scope.$digest();
                }
            }

            function toggleViewCompare(){
                scope.compareViewEdit=!scope.compareViewEdit;
            }
            // Create filtermap for all requests
            function createFilterMap({contentControlId, clauseVersion, categoryInstances, documentFileId} = {}) {
                if(!_.isEmpty(retainSortCol)) {
                    scope.sortCol =  {...retainSortCol};
                    retainSortCol = {};
                }
                const analyticsStatsScope = $('[cdr-analytic-stats]').scope(),
                filterMapForClause = {
                    "filterMap": {
                        ...!(scope.clauseCategoryId && scope.groupId) && {
                            "offset": scope.page.offset,
                            "size": scope.page.size
                        },
                        "orderByColumnName": scope.sortCol.name,
                        "orderDirection": scope.sortCol.order,
                        "entityTypeId": scope.data.entityTypeId.values,
                        "customFilter": {
                            "clauseDeviationFilter": {
                                ...((!categoryInstances && !contentControlId) && {
                                    "deviationStatusList": analyticsStatsScope?.analyticsStatsData.selectedActivity ? [analyticsStatsScope.analyticsStatsData.selectedActivity.id] : [],
                                    "categoryType": analyticsStatsScope?.analyticsStatsData.selectedCategory ? [analyticsStatsScope.analyticsStatsData.selectedCategory.id] :  [],
                                    "deviationSeverityStatus": analyticsStatsScope?.analyticsStatsData?.selectedDeviationPriority ? [analyticsStatsScope.analyticsStatsData.selectedDeviationPriority.id] : [],
                                    "reviewStatus": analyticsStatsScope?.analyticsStatsData?.selectedReviewStatus ? [analyticsStatsScope.analyticsStatsData.selectedReviewStatus.id] : []
                                }),
                                "documentFileId": documentFileId || scope.docFileSelectedId,
                                "entityId": scope.data.id.values,
                                "deviationReference": analyticsStatsScope?.deviationReference?.id || null
                            }
                        },
                        "filterJson": {}
                    }
                }

                if (contentControlId) {
                    filterMapForClause.filterMap.customFilter.clauseDeviationFilter['contentControlId'] = contentControlId;
                    filterMapForClause.filterMap.customFilter.clauseDeviationFilter['documentId'] = scope.selectedDocId;
                }
                if (scope.selectedDocId) {
                    filterMapForClause.filterMap.customFilter.clauseDeviationFilter['documentId'] = scope.selectedDocId;
                }
                if (clauseVersion) {
                    filterMapForClause.filterMap.customFilter.clauseDeviationFilter['clauseVersion'] = clauseVersion;
                }
                if (scope.clauseCategoryId) {
                    filterMapForClause.filterMap.customFilter.clauseDeviationFilter['categoryId'] = scope.clauseCategoryId;
                }
                if (scope.groupId) {
                    filterMapForClause.filterMap.customFilter.clauseDeviationFilter['groupId'] = scope.groupId;
                }
                filterMapForClause.filterMap.customFilter.clauseDeviationFilter = {
                    ...filterMapForClause.filterMap.customFilter.clauseDeviationFilter,
                    ...categoryInstances && {categoryInstances},
                }
                return filterMapForClause;
            }

            // Fetch Table Data
            function fetchTableDataForDocument() {
                // Preload & mount CKE4 with blank data to improve performance

                let dataToPost = createFilterMap();
                let snackBar = angular.element('.analytic-buttons p.totalStatsCount');

                let sc = $('[cdr-analytic-stats]').scope();

                return $q.all(apiList.map(function (item) {
                    if (sc.fromCardDeviation) {
                        dataToPost['filterMap']['offset'] = 0
                    }
                    const apiUrl = ((apiList[0] == item && isFirstRequest) ? item + "?entityId=" + scope.data.id.values + "&entityTypeId=" + scope.data.entityTypeId.values : item);
                    return http({
                        method: 'POST',
                        url: '/v3/listRenderer/list/492/' + apiUrl,
                        data: (apiList[0] == item && isFirstRequest) ? {} : dataToPost
                    });
                })).then(function (results) {
                    scope.resultObj = {};
                    results.forEach(function (val, i) {
                        scope.resultObj[apiList[i]] = val.data;
                    });
                    populateClauseTableData();
                    scope.showAnalytics = true;
                    stopLoader();

                    if(isFirstRequest){
                        scope.analyticsTableColumns = scope.resultObj.defaultUserListMetaData.columns;
                        snackBar.addClass('active');
                        // Disable all things that are not meant for consecutive calls
                        apiList.shift();
                        isFirstRequest = false;
                        timeout(function() {
                            // Hide toast bar after initial load
                            snackBar.removeClass('active');
                        }, 2000);
                    }
                }, function errorCallback(error) {
                    console.error('Data cannot be loaded due to: ' + error);
                });
            }


            function populateClauseTableData() {
                // Populate table data
                const analyticsTableColumns = (scope.resultObj.defaultUserListMetaData && scope.resultObj.defaultUserListMetaData.columns) ? scope.resultObj.defaultUserListMetaData.columns : scope.analyticsTableColumns,
                    listData = scope.resultObj.listdata.data;

                scope.totalAnalyticsTableData = scope.resultObj.listdata.totalCount;

                if (angular.isDefined(analyticsTableColumns) && angular.isDefined(listData)) {
                    if (!listData.length) {
                        scope.isEmptyAnalyTicsTableData = true;
                    }
                    scope.hiddenColumnsName = [];
                    if(!scope.visibleColumns || !scope.visibleColumns.length) {
                        let visibleColumns = analyticsTableColumns.filter(function (value) {
                            if (value.displayFormat && JSON.parse(value.displayFormat).hideColumn == true) {
                                scope.hiddenColumnsName.push(value.queryName);
                            }
                            let displayFormat;
                            value.displayFormat && (displayFormat = JSON.parse(value.displayFormat));
                            displayFormat && (value.sortable = displayFormat.sortable == false ? false : true);
                            value.isAsc = value.isDsc = false;
                            return (displayFormat && displayFormat.hideColumn !== true);
                        });
                        scope.visibleColumns = _.orderBy(visibleColumns, 'order');
                    }
                    scope.analyticsTableColumns = analyticsTableColumns;
                    if (scope.totalAnalyticsTableData > (scope.page.number * scope.page.size)) {
                        // scope.page.number += 1;
                        scope.page.offset = scope.page.size * scope.page.number;
                    } else {
                        scope.canLoadMoreClauses = false;
                    }
                    scope.analyTicsTableData = cdrDataTransformService.cdrTransform(scope.analyticsTableColumns, listData, scope.hiddenColumnsName, 'contentControlId');
                } else {
                    scope.analyTicsTableData = undefined;
                }
              if(scope.analyTicsTableData) {
                  for (let [key, value] of Object.entries(scope.analyTicsTableData)) {
                      if (value.flowdownclause) {
                          scope.updatedData.push(value.contentControlId + '_' + scope.docFileSelectedId)
                      }
                  }
              }
            }
            scope.hideHeader = function(queryName){
                const headers = [];
                window.location.href.indexOf('tblcontracts') > -1 && headers.push('deviationStatus','aeDeviationScore','wordDeviationScore','reviewTaskDetail');
                return !(headers.indexOf(queryName) > -1) ;
            }
            scope.mapDeviationSeverityToIconForListing = {
                "0": 'risk_low',
                "1": 'risk_medium',
                "2": 'risk_high'
            }


            // Initialize clause table
            scope.initClauseTable = function (deviationStatus) {
                startLoader();
                scope.reInitScopeVar();
                return fetchTableDataForDocument();
            }

            scope.initClauseTableBySortOrder = function (data) {
                if(!data.sortable)
                    return;

                startLoader();
                scope.reInitScopeVar();
                _.forEach(scope.visibleColumns,col => {
                    if(data.queryName != col.queryName)
                        col.isAsc = col.isDsc = false;
                })

                if(!data.isAsc && !data.isDsc)
                    data.isAsc = true;
                else if(data.isAsc || data.isDsc) {
                    data.isAsc = !data.isAsc;
                    data.isDsc = !data.isDsc
                }
                let order = data.isAsc ? 'asc' : 'desc';
                scope.setSortCol(data.queryName,order);
                fetchTableDataForDocument();
            }

            // Map color for deviation status inside of cluase deviation table
            scope.mapDeviationStatusColor = function (id, inPopup) {
                switch (parseInt(id)) {
                    case 1:
                        return 'yellow';
                    case 2:
                        return 'blue';
                    case 3:
                        return 'red';
                    case 4:
                        if(inPopup) { return 'no-color'; }
                        return 'green';
                }
            }

            scope.mapDeviationSeverityToIcon = {
                "0": 'risk_low',
                "1": 'risk_medium',
                "2": 'risk_high'
            }

            scope.mapDeviationStatusName = {
                "2" : "Added",
                "3" : "Deleted",
                "1": "Modified",
                "6" : "Pending Approval",
                "5" : "Review Pending",
                "14":"Moved"
            }

            // Control actions
            scope.toggleSubversionsVisibility = e => {
                e.preventDefault();
                e.stopPropagation();
                const activeDocument = angular.element(e.currentTarget).closest('li');
                (activeDocument.hasClass('doc-expanded-view')) ? activeDocument.removeClass('doc-expanded-view') : activeDocument.addClass('doc-expanded-view');
            }

            // Activate list item inside left list
            scope.activateListItem = (e, docProp) => {
                e.preventDefault();
                e.stopPropagation();
                document.body.click();
                const currentDocument = angular.element(e.currentTarget).closest('.docContainer');
                let docFileId = docProp.fileId;
                if (docFileId !== scope.docFileSelectedId) {
                    startLoader();
                    scope.visibleColumns?.forEach(visibleColumn => {visibleColumn['isAsc'] = false; visibleColumn['isDsc'] = false;})
                    angular.element('.sub-versions > li').removeClass('active');
                    if (angular.element(e.currentTarget).parent().hasClass('sub-versions')) {
                        angular.element(e.currentTarget).addClass('active');
                    }
                    scope.activeListItemIndex = currentDocument.index();
                    scope.selectedDocId = currentDocument.attr('docId');
                    updateDocFileId(docProp);
                }
            }

            scope.downloadDocClick = function (e, link, fileObj=null) {
                listService.downloadDocClick(e, link, fileObj, true); // Added additional flag to handle cropping of drop down in clause section in cdr
            }

            scope.downloadPDF = function (e, numArr, fileObj=null) {
                listService.downloadPDF(e, numArr, fileObj);
            };

            // Load children data for Clauses table
            scope.loadChildrenData = function (key, clauseVersion, shouldCompareDocs, row, e) {
                const rowData = row && row.myRowData,
                    isReviewEditable = rowData?.reviewTaskDetail?.reviewEditable == 'true' ?? false,
                    isReviewInProgress = (rowData?.reviewTaskDetail?.value?.currentTask?.finalTask == false ) ?? false,
                    loadEditViewAsDefault = false;

                scope.contentControlId = row && row.contentControlId;
                // rootScope.compareWindowOnly = false;
                let isDeletedEntity = rowData && (rowData.clauseVersion.statusCode == '3');
                if(isDeletedEntity && shouldCompareDocs){
                    return;
                }
                scope.clauseCategoryId = rowData?.clauseCategoryId?.value;
                scope.groupId = rowData?.groupId?.value;
                startLoader();
                scope.clauseVersion = clauseVersion;
                if(rowData && shouldCompareDocs){
                    scope.rowData = rowData;
                }
                if(shouldCompareDocs && rowData && rowData.reviewTaskDetail){
                    scope.reviewTaskDetail = rowData.reviewTaskDetail;
                    if (rowData.reviewTaskDetail.value && 'revertVersion' in rowData.reviewTaskDetail.value) {
                        scope.revertedVersion[row.contentControlId] = _.get(rowData.reviewTaskDetail, 'value.revertVersion');
                    }else{
                        scope.revertedVersion[row.contentControlId] = false;
                    }
                }
                if (angular.isDefined(e)) {
                    e.stopPropagation();
                    let parentRow = angular.element(e.currentTarget).closest('tr.itemContainer');
                    if (parentRow.hasClass('isExpandedView')) {
                        parentRow.removeClass('isExpandedView');
                        scope.analyTicsTableData[key].childData = {};
                        stopLoader();
                        return;
                    } else {
                        parentRow.addClass('isExpandedView');
                    }
                }

                if (clauseVersion !=='1'){
                    const dataToPost = createFilterMap({contentControlId: key, clauseVersion });
                    http({
                        method: 'POST',
                        url: '/v3/listRenderer/list/492/' + (apiList[1] || apiList[0]),
                        data: dataToPost
                    }).then(function (response) {
                        let listData = response.data.data;
                        scope.analyTicsTableData[key].childData = cdrDataTransformService.cdrTransform(scope.analyticsTableColumns, listData, scope.hiddenColumnsName, 'documentFileId', true);

                        if (shouldCompareDocs) {
                            scope.compareDocs(key, null, loadEditViewAsDefault);
                            // rootScope.compareWindowOnly = true;
                        } else {
                            scope.clauseCategoryId = null;
                            scope.groupId = null;
                            stopLoader();
                        }
                    }, function errorCallback(error) {
                        console.error('Data cannot be loaded due to: ' + error);
                    });
                } else{
                    if (shouldCompareDocs) {
                        scope.compareDocs(key, null, loadEditViewAsDefault);
                    }
                    stopLoader();
                }
            };

            scope.loadClausesData = function () {
                const dataToPost = createFilterMap({ categoryInstances: true, documentFileId: scope.rowData?.documentFileId?.value });
                return http({
                    method: 'POST',
                    url: '/v3/listRenderer/list/492/' + (apiList[1] || apiList[0]),
                    data: dataToPost
                });
            }

            // Load more on scroll
            scope.loadMoreClauses = function () {
                if (!scope.canLoadMoreClauses) {
                    return;
                }
                let dataToPost = createFilterMap();
                if(scope.totalAnalyticsTableData > (scope.page.number * scope.page.size)) startLoader();
                http({
                    method: 'POST',
                    url: '/v3/listRenderer/list/492/' + (apiList[1] || apiList[0]),
                    data: dataToPost
                }).then(function (response) {
                    stopLoader();
                    const listData = response.data,
                        additionalListData = listData.data;
                    scope.additionalAnalyticsTableData = cdrDataTransformService.cdrTransform(scope.analyticsTableColumns, additionalListData, scope.hiddenColumnsName, 'contentControlId');
                    let mergedTableData = _.merge(scope.analyTicsTableData, scope.additionalAnalyticsTableData);
                    scope.analyTicsTableData = angular.copy(mergedTableData);
                    if (scope.totalAnalyticsTableData > (scope.page.number * scope.page.size)) {
                        scope.page.number += 1;
                        scope.page.offset = scope.page.size * scope.page.number;
                    } else {
                        scope.canLoadMoreClauses = false;
                    }
                    if (scope.totalAnalyticsTableData == (scope.page.number * scope.page.size)) {
                        scope.canLoadMoreClauses = false;
                    }
                    for (let [key, value] of Object.entries(scope.analyTicsTableData)) {
                        if(value.flowdownclause){
                            scope.updatedData.push(value.contentControlId+'_'+scope.docFileSelectedId)
                        }
                    }
                }, function errorCallback(error) {
                    console.error('Data cannot be loaded due to: ' + error);
                });
            };

            scope.createUserInitals = function(userName){
                return globalFunc.getUserInitials(userName);
            }

            scope.modifyData = (listData) => {
                listData.forEach(function (e, i) {
                    if (e.version == '1') {
                        e.versionLabel = (intl_msg[29885] || "Approved Clause") + " (" + (intl_msg[29890] || "Version") + " 1)";
                    } else if (e.version == listData[listData.length - 1].version) {
                        e.versionLabel = (intl_msg[29887] || "Current Version") + " -" + (intl_msg[29890] || "V") + " " + e.version;
                    } else {
                        e.versionLabel = (intl_msg[29886] || "Clause Version") + " " + e.version;
                    }
                });
            }

            scope.getCompPostText = (col, currentRow) => {
                if(_.get(currentRow,`myRowData[${col.queryName}].value`) != '-' && _.get(currentRow,`myRowData[${col.queryName}].colName`) == 'companyPosition') return true;
                else return false;
            };

            // Build initial data for clause comparison modal
            scope.compareDocs = (key, currentRow, editMode=false) => {
                // Preload & mount CKE4 with blank data to improve performance
                mountCkEditor('#dummyInstanceForCKE');

                // Early exit for deleted versions
                if(currentRow && ( _.get(currentRow, 'myRowData.clauseVersion.statusCode') == '3' ) ) {
                    window.systemWarning('You\'re trying to access deleted clause.');
                    return false;
                }

                if (currentRow) {
                    scope.clauseCategoryId = currentRow?.myRowData?.clauseCategoryId?.value;
                    scope.groupId = currentRow?.myRowData?.groupId?.value;
                }
                scope.editModeActive = editMode;

                scope.htmlContent = {
                    'reviewWindow': null,
                    'editWindow': null
                };
                let compareDocumentFileiId;
                scope.isChildRow = false;
                scope.activeWindow = {
                    'edit': false,
                    'compare': false
                };
                scope.reviewContent = {
                    'initial': {
                        'html': null,
                        'inlineTags': null,
                        'inlineTagsCopy': null
                    },
                    'final':{
                        'inlineTags': null
                    }
                }
                window.sarc.channelSubscription('clauseReconcillation', function(deletedTagIds){
                    updateDeletedTagsInTagsWindow(deletedTagIds);
                }, "deletedTags");
                if(currentRow){
                    scope.isChildRow = true;
                    scope.rowData = currentRow.myRowData;
                    scope.reviewTaskDetail = undefined;
                    scope.clauseVersion = currentRow.myRowData.clauseVersion.value;
                    compareDocumentFileiId = currentRow.id;
                }
                scope.reviewDataToPost = {
                    "contentControlId": currentRow && currentRow.contentControlId ? currentRow.contentControlId : key ,
                    "documentFileId": compareDocumentFileiId || scope.docFileSelectedId
                }
                const compareDataToPost = {
                    "sourceDocumentFileId": null,
                    "compareDocumentFileiId": compareDocumentFileiId || scope.docFileSelectedId,
                    "documentId": scope.selectedDocId
                }
                scope.compareDocFileIds = {
                    'source': null,
                    'compare': compareDataToPost.compareDocumentFileiId
                }

                let currentCompareRowKey = scope.analyTicsTableData[key],
                    transformedCompareData = [],
                    compareData = {
                        'version': _.get(currentCompareRowKey.myRowData, 'clauseVersion.value'),
                        'documentFileId': scope.docFileSelectedId,
                        'category': _.get(currentCompareRowKey.myRowData, 'clauseCategory.value'),
                        'modifiedBy': _.get(currentCompareRowKey.myRowData, 'modifiedBy.value'),
                        'modifiedOn': _.get(currentCompareRowKey.myRowData, 'modifiedOn.value')
                    }

                // If Parent row status is deviated(1), (added(2) or removed(4) & version greater than 1) only then push it
                const isCompareAllowed = currentCompareRowKey.myRowData.clauseVersion.statusCode == '1' || ( (currentCompareRowKey.myRowData.clauseVersion.statusCode == '2' || currentCompareRowKey.myRowData.clauseVersion.statusCode == '4') && currentCompareRowKey.myRowData.clauseVersion.value != '1');
                if (isCompareAllowed) {
                    transformedCompareData.push(compareData);
                }else{
                    stopLoader();
                    window.systemWarning('Document version is 1 or Document status is not equal to 1, 2, 4');
                }
                Object.keys(currentCompareRowKey.childData || {}).forEach(function (key) {
                    let compareData = {
                        'version': _.get(currentCompareRowKey.childData[key].myRowData, 'clauseVersion.value'),
                        'documentFileId': key,
                        'category': _.get(currentCompareRowKey.childData[key].myRowData, 'clauseCategory.value'),
                        'modifiedBy': _.get(currentCompareRowKey.childData[key].myRowData, 'modifiedBy.value'),
                        'modifiedOn': _.get(currentCompareRowKey.childData[key].myRowData, 'modifiedOn.value')
                    }

                    if (currentCompareRowKey.childData[key].myRowData.clauseVersion.statusCode == '1' ||
                        currentCompareRowKey.childData[key].myRowData.clauseVersion.statusCode == '2' ||
                        currentCompareRowKey.childData[key].myRowData.clauseVersion.statusCode == '4' ) {
                        transformedCompareData.push(compareData);
                    }
                });
                transformedCompareData = _.orderBy(transformedCompareData, 'version');
                scope.modifyData(transformedCompareData);

                scope.compareData = angular.copy(transformedCompareData);

                scope.compareDataForBaseText = angular.copy([compareData]);
                scope.modifyData(scope.compareDataForBaseText);

                scope.compareDataToPost = angular.copy(compareDataToPost);
                scope.myModelInstance = $modal.open({
                    templateUrl: scope.createHtmlUrl("ui2.0/compareDocsModal.html"),
                    modal: true,
                    size: "lg",
                    backdrop: "static",
                    keyboard: false,
                    scope: scope,
                    windowClass: "clonepopup "
                });
                scope.myModelInstance.result.then(function () {
                    delete scope.myModelInstance;
                })
            }

            scope.closeCompareDocModal = function () {
                startLoader();
                rootScope.compareWindowOnly = false;
                scope.editModeActive = false;
                hasValidationError = false;
                scope.uniqueClauseIds = [];
                scope.clauseCategoryId = null;
                scope.groupId = null;
                window.sarc.channelUnsubscription('clauseReconcillation', "deletedTags");
                scope.myModelInstance.close();
                // scope.expandDeviationSummary = false;
                scope.scoreFeatureVersion = null;
                retainSortCol = scope.sortCol ? {...scope.sortCol} : {};
                refreshAnalyticsAndTable();
            };

            function refreshAnalyticsAndTable() {
                startLoader();
                window.sarc.channelUnsubscription('clauseReconcillation', "deletedTags");
                const retainDocFileID = scope.docFileSelectedId,
                retainDocFileFormat = scope.docFileSelectedFormat,
                analyticsStatsScope = $('[cdr-analytic-stats]').scope();
                if(analyticsStatsScope) analyticsStatsScope.blockFilterReset = true;
                var obj = {
                    'fileId': retainDocFileID,
                    'format': retainDocFileFormat
                }
                updateDocFileId(null);
                timeout(function() {
                    updateDocFileId(obj);
                }, 100);
            }

            var createFilterForStateMachine = function(btn, requestFromOutside) {
                let updatedContent, finalTags;
                if(scope.activeWindow.edit && !requestFromOutside){
                    const newContent = window?.editor?.editor.getData();
                        finalTags = scope.reviewContent.initial.inlineTags.map(tag => {
                            tag.value = (tag.value == '') ? null : tag.value;
                            return _.omit(tag, ['optionsData', 'displayValue']);
                        });
                    if(newContent !== scope.reviewContent.initial.html || !_.isEqual(_.sortBy(scope.reviewContent.initial.inlineTagsCopy), _.sortBy(finalTags))){
                        updatedContent = window?.editor?.editor.getData();
                    }
                }

                let filterObj = {
                    "contentControlId": scope.reviewDataToPost.contentControlId,
                    "documentFileId" : scope.reviewDataToPost.documentFileId,
                    "modifiedText" : updatedContent || null
                };

                if(btn){
                    filterObj.reviewTaskDetail = btn;
                }
                if(!requestFromOutside && scope.reviewContent.initial.inlineTags && scope.reviewContent.initial.inlineTags.length > 0){
                    filterObj.inlineTags = finalTags;
                }
                return filterObj;
            }

            // Perform final task clause review (Cancel/ Process/ Complete/ Save)
            scope.performTask = function (btn, requestFromOutside, key) {
                const args = Array.from(arguments),
                    addConfirmDialog = !requestFromOutside && btn && btn.taskButtonName === 'Cancel Review',
                    performTask = () => {
                        if(!hasValidationError) {
                            startLoader();
                            saveClauseAndTags.apply(null, args);
                        }
                    };

                addConfirmDialog ? confirmDialog(intl_msg[6794], performTask) : performTask();
            };

            scope.updateFlowDownClause = function (contentControlId, flowDownId) {
                if (scope.updatedData.includes(flowDownId)) {
                    const index = scope.updatedData.indexOf(flowDownId);
                    scope.updatedData.splice(index, 1);
                    flowDownClause=false;
                } else {
                    scope.updatedData.push(flowDownId);
                    flowDownClause=true;
                }
                const dataToPost = {
                    "flowDownClause": flowDownClause,
                    "documentFileId": parseInt(scope.docFileSelectedId),
                    "contentControlId": contentControlId,
                    "entityId": scope.data.id.values,
                    "entityTypeId": scope.data.entityTypeId.values
                };
                http({
                    method: 'POST',
                    url: '/tblcdr/updateFlowDownClause',
                    data: dataToPost
                }).then(function (response) {
                }, function errorCallback(error) {
                });
            }

            function saveClauseAndTags(btn, requestFromOutside, key){
                if(requestFromOutside){
                    scope.activeWindow = {
                        'edit': false,
                        'compare': false
                    };
                    scope.reviewDataToPost = {
                        "contentControlId": key,
                        "documentFileId": scope.docFileSelectedId
                    }
                }
                let dataToPost = createFilterForStateMachine(btn, requestFromOutside);
                http({
                    method: 'POST',
                    url: '/tblcdr/review/performTask',
                    data: dataToPost
                }).then(function(response) {
                    if (requestFromOutside) refreshAnalyticsAndTable();
                    if (btn && [1002, 1003].indexOf(btn.taskId) != -1) {
                        window.sarc.channelBroadcast("contractClauseCard", {
                            actionType:'updateContractCardData'
                        }, 'contractClauseCardSubscription')
                        const analyticsStatsScope = $('[cdr-analytic-stats]').scope();
                        analyticsStatsScope.loadAnalytics({notInitRequest: true});
                        scope.closeCompareDocModal();
                    }
                    else if(!requestFromOutside) {
                        let sc = $('[compare-doc-modal]').scope()
                        sc.changeView(false);
                    }
                    timeout(function () {
                        stopLoader();
                    }, 300);
                }, function errorCallback(error) {
                    console.error('Data cannot be loaded due to: ' + error);
                });
            }

            function updateDeletedTagsInTagsWindow(deletedTags) {
                scope.reviewContent.initial.inlineTags.map(function(obj){
                    if(deletedTags.indexOf(obj.id) > -1){
                        obj.deleted = true;
                    } else{
                        obj.deleted = false;
                    }
                });
                scope.$applyAsync();
            }

            scope.validateAndPerformTask = function() {
                promise ? promise.then(() => scope.performTask()) : scope.performTask();
            }

            scope.validateServerValidationRules = function (fieldLevel, ...args) {
                let postDataArr = [], promiseResolve, promiseReject;
                angular.forEach(scope.reviewContent.initial.inlineTags, function(obj, i){
                    if(obj.value && obj.value != "" && obj.value != null && !!obj.tagId){
                        let postObj = {
                            "id" 			: obj.tagId,
                            "name" 			: obj.name,
                            "defaultValue"	: obj.value
                        };

                        if (obj?.dateFormat && obj.dateFormat.trim() !== "") {
                            postObj.dateFormat = obj.dateFormat;
                        }

                        postDataArr.push(postObj);
                    }
                });

                // If no changes made to tags
                if(postDataArr.length == 0 && !fieldLevel){
                    saveClauseAndTags.apply(null, args);
                    return;
                }

                promise = null;
                if(fieldLevel == true) {
                    promise = new Promise((resolve, reject) => {
                        promiseResolve = resolve;
                        promiseReject = reject;
                    })
                }

                // ValidateTags and append messages in UI
                http({
                    dataType: "json",
                    data: JSON.stringify(postDataArr),
                    contentType: "application/json;charset=UTF-8",
                    method: 'POST',
                    url: appName+"/tagValidation"
                }).then(function(res){
                    if(res.data && res.data.response){
                        hasValidationError = false;
                        angular.forEach(res.data.response, function (obj, i) {
                            if(obj.valid == false && obj.validationErrorMessages && obj.validationErrorMessages.length > 0){
                                angular.forEach(scope.reviewContent.initial.inlineTags, function(tag){
                                    if(i == tag.tagId) {
                                        tag.serverValidationMessage = obj.validationErrorMessages[0].errorMessage;
                                        tag.serverValidationFail = true;
                                    }
                                });
                                hasValidationError = true;
                            } else {
                                angular.forEach(scope.reviewContent.initial.inlineTags, function(tag){
                                    if(i == tag.tagId) {
                                        if (tag.hasOwnProperty('serverValidationMessage') || tag.hasOwnProperty('serverValidationFail')) {
                                            delete tag.serverValidationMessage;
                                            delete tag.serverValidationFail;
                                        }
                                    }
                                });
                            }
                        });
                    }
                    // Show alert if validation
                    if(hasValidationError == true || fieldLevel){
                        if(fieldLevel != true){
                            SirionUtils.openSirionDialogs({popupType: 'alert', str: intl_msg[23526], heading: intl_msg[24153]});
                            stopLoader();
                        }
                        if(promise) {
                            hasValidationError ? promiseReject() : promiseResolve();
                        }
                    } else{
                        saveClauseAndTags.apply(null, args);
                    }
                }).catch(error => window.systemWarning(error));
            };

            scope.convertDateFormatToUpperCase = function(tagDateFormat) {
                return tagDateFormat.toUpperCase();
            }

            scope.getTooltipForCurrentTask = function(currentRow) {
                let labelId = currentRow?.currentTask?.labelId,
                    performedDate = currentRow.performedOn ? (" | " + currentRow.performedOn) : '',
                    currentTaskLabel = intl_msg[labelId] ? (" - " + intl_msg[labelId]) : '',
                    helpText = currentRow.performedBy + currentTaskLabel + performedDate;
                return helpText;
            }

            scope.trustAsHtml = (string) =>{
                return sce.trustAsHtml(string);
            }
        }
    }
}]);

angular.module('ui2.0Directives').directive('compareDocsModal', ['$http', '$rootScope', '$sce', '$timeout', '$compile', 'filterService', 'cdrDataTransformService', function (http, rootScope, sce, timeout, compile, filterService, cdrDataTransformService) {
    return {
        restrict: 'E',
        templateUrl: rootScope.createHtmlUrl("ui2.0/directiveTemplates/compareDocs.html"),
        link: function (scope, element, attrs) {
            startLoader();
            scope.actionButtons;
            scope.clauseDeviationScoreInfo = {}
            scope.isBaseTextComparision = false;
            // Compare Window related variables;
            scope.version1 = {};
            scope.version2 = {};
            scope.isCompareListActive;
            scope.isCompareVersionListActive;
            scope.htmlTextDDActive;
            scope.html = {
                original: null,
                new: null,
                diff: null,
                parent: null
            };

            scope.text = {
                original: null,
                new: null,
                diff: null,
                parent: null
            }

            scope.versionDiffComparisonWindow = false;

            scope.comparisonTypes = [{id: 1, label: 'Text'}, {id: 2, label: 'HTML'}];
            scope.selectedComparisonType = scope.compareModeOnly ? scope.comparisonTypes[0] : {};
            // scope.selectedDDComparisonType = scope.comparisonTypes[0];

            scope.selectedDeviationTabIndex = 1;

            scope.clauseCompareInfo;
            let compareDataToPostKeys = ['sourceDocumentFileId', 'compareDocumentFileiId'];

            // Comments section
            scope.newComment;
            scope.enableCommentAddition = false;
            scope.isNewCommentsBoxVisible = false;
            // scope.expandDeviationSummary = false;

            // New flag for intermediatory version
            scope.intermediateVersion = false;

            // scope.toggleExpandDeviationSummary = () => {
            //     scope.expandDeviationSummary = !scope.expandDeviationSummary;
            // }

            scope.changeDeviationTab = (index) => {
                scope.selectedDeviationTabIndex = index;
            }

            // Activate compare window and call CompareDocversions on Compare click
            scope.activateCompareView = () => {
                mountCkEditor('#dummyInstanceForCKE');
                if ((scope.isBaseTextComparision || !scope.compareModeOnly) && !_.get(scope.compareData, "length")) {
                    scope.compareData = angular.copy(scope.compareDataForBaseText);
                }
                if (!scope.originalDocFileId && scope.compareDocFileIds && _.get(scope.compareData, "length"))
                    scope.originalDocFileId = (scope.compareDocFileIds.source) ? scope.compareDocFileIds.source : scope.compareData[0].documentFileId;
                // scope.latestVersionDocFileId = scope.compareData[scope.compareData.length - 1].documentFileId;
                scope.newDocFileId = scope.compareDocFileIds.compare;
                scope.allDocVersions = angular.copy(scope.compareData);

                // Initialize versions to populate modal options
                if(scope.compareModeOnly) {
                    scope.version1 = angular.copy(scope.allDocVersions.find(e => {
                        return e.documentFileId == scope.originalDocFileId
                    }));
                    scope.currentV1 = scope.version1.documentFileId;
                }
                scope.version2 = angular.copy(scope.allDocVersions.find(e => {
                    return e.documentFileId == scope.newDocFileId
                }));
                scope.clonedCompareDocsData = angular.copy(scope.compareData);
                scope.currentV2 = scope.version2.documentFileId;
                let _docVersions1 = scope.allDocVersions.filter(v => {
                    return scope.compareModeOnly ? (v.version != scope.version2.version) : (v.version < scope.version2.version)
                });
                scope.docVersions1 = angular.copy(_docVersions1);
                let _docVersions2 = scope.allDocVersions.filter(v => {
                    return v.version != scope.version1.version
                });
                scope.docVersions2 = angular.copy(_docVersions2);
                // scope.isRevertClicked = false;
                updateDocVerArrForCompareWithDD();
                if (scope.baseTextComparision && scope.docVersions1 && (scope.allDocVersions.length > 1 || !scope.compareModeOnly) && !_.find(scope.docVersions1, ['versionLabel', intl_msg[30189]])) {
                    scope.docVersions1.push({versionLabel: intl_msg[30189], version: 'baseText'})
                    scope.isBaseTextButton = true;
                }
                if (!scope.editModeActive)
                    scope.compareDocVersions(!scope.compareModeOnly ? 2 : undefined);
            }

            scope.changeVersionView = (fromText = false) => {
                startLoader();
                scope.toggleCompareOptions(false);
                if(!scope.versionDiffComparisonWindow) {
                    scope.selectedComparisonType = fromText ? scope.comparisonTypes[0] : scope.comparisonTypes[1];
                }
                scope.versionDiffComparisonWindow = !scope.versionDiffComparisonWindow;
                setTimeout(() => {
                    stopLoader();
                }, 500)
            }

            scope.toggleCompareOptions = (isListActive) => {
               scope.isCompareListActive = isListActive;
            }

            scope.toggleHTMLTextDD = (event, comparisonType) => {
                event && event.stopPropagation();
                scope.htmlTextDDActive = scope.htmlTextDDActive && scope.htmlTextDDActive.id == comparisonType.id ? null : comparisonType;
            }

            scope.toggleVersionCompareOpts = (isListActive) => {
                scope.isCompareVersionListActive = isListActive;
                scope.htmlTextDDActive = null;
                if (_.isEmpty(scope.selectedComparisonType) && isListActive) {
                    scope.selectedComparisonType = scope.comparisonTypes[0];
                }
            }

            scope.selectDDComparisonType = (event, type) => {
                event.stopPropagation();
                scope.selectedComparisonType = type;
            }

            scope.prevCompareVerChangeAndToggleViewCompare = (selectedVersionFileId, comparisonTypefromTemplate) => {
                scope.prevCompareVerChange(selectedVersionFileId, comparisonTypefromTemplate);
                scope.toggleVersionCompareOpts(false);
                if(!scope.viewCompareEdit) {
                    scope.viewCompareEdit = true;
                }
            }

            scope.prevCompareVerChange = (selectedVersionFileId, comparisonTypefromTemplate) => {
                const isEqualToLatestVersion = selectedVersionFileId == scope.version2.documentFileId;
                scope.version1 = isEqualToLatestVersion ? {} : scope.docVersions1.find(docVersion1ListItem => docVersion1ListItem.documentFileId == selectedVersionFileId);
                scope.toggleCompareOptions(false);
                scope.selectedComparisonType = comparisonTypefromTemplate;
                if(isEqualToLatestVersion) {
                    scope.selectedComparisonType = {};
                    scope.docVersions1 = scope.allDocVersions.filter(v => {
                        return v.documentFileId != scope.version2.documentFileId
                    });
                    scope.activateCompareView();
                } else {
                    // !_.find(scope.docVersions1, ['isStandard', true]) &&
                    // scope.docVersions1.push({...scope.version2, 'isStandard': true});
                    scope.compareDocVersions(1);
                }
                scope.versionDiffComparisonWindow = !isEqualToLatestVersion;
                if (scope.versionDiffComparisonWindow) {
                    scope.selectedDeviationTabIndex = 1;
                } else {
                    scope.resetTab();
                }
            }

            const setVersionAndDeviationScoreInfo = (changedVersion) => {
                if (scope.version1 && !scope.version1.documentFileId && changedVersion == 1) {
                    scope.isBaseTextComparision = true;
                    scope.currentV1 = scope.version1.documentFileId;
                    _docVersions2 = scope.allDocVersions && scope.allDocVersions.length && scope.allDocVersions.filter(v => {
                        return v.documentFileId != scope.version1.documentFileId
                    });
                    scope.docVersions2 = angular.copy(_docVersions2);
                } else{
                    if (!scope.compareModeOnly || _.get(scope.docVersions1, "length") > 1) scope.isBaseTextComparision = false;
                    scope.clauseDeviationScoreInfo = {};
                    scope.isSummaryPresent = false;

                    if(scope.version1 && !scope.version1.documentFileId && scope.originalDocFileId && (!scope.compareModeOnly && changedVersion == 1)) {
                        scope.version1 = angular.copy(scope.allDocVersions.find(e => {
                            return e.documentFileId == scope.originalDocFileId
                        }))
                    }
                }
            }

            // Compare document versions
            scope.compareDocVersions = (changedVersion) => {
                scope.intermediateVersion = false;
                let lastELem = scope.clonedCompareDocsData &&  scope.clonedCompareDocsData[scope.clonedCompareDocsData.length - 1];
                setVersionAndDeviationScoreInfo(changedVersion);
                startLoader();
                if (scope.compareModeOnly) {
                    return scope.compareClauseData(changedVersion, lastELem);
                }
                    return scope.loadClausesData().then ((listResponse) => {
                        const listResponseJson = createColorAndStatusListJson(listResponse);
                        return scope.compareClauseData(changedVersion, lastELem, listResponseJson);
                    })
                
            }

            const createColorAndStatusListJson = (listResponse) => {
                let listResponseJson = {};
                const listData = listResponse?.data?.data;
                listData && listData.forEach((clauseItem) => {
                    const idEntry = _.find(clauseItem, { columnName: "contentControlId" });
                    const idValue = idEntry.value;

                    const result = {
                        [idValue]: _.reduce(clauseItem, (acc, obj) => {
                            if(obj.columnName == 'companyPosition' && obj.value?.indexOf(':;') > -1) {
                                const valArr = obj.value.split(':;');
                                if(valArr[1]?.split('#')[1]) {
                                    valArr[1] = '#'+cdrDataTransformService.colorMixFn({"color_2": valArr[1].split('#')[1], "color_1": 'ffffff', weight: 85});
                                    obj.value = valArr.join(':;');
                                }
                            }
                            acc[obj.columnName] = obj.value;
                            if (obj.columnName === "reviewTaskDetail") {
                                acc[obj.columnName] = JSON.parse(obj.value);
                                if (obj?.value) scope.revertedVersion[idValue] = JSON.parse(obj.value).revertVersion;
                            }

                            return acc;
                        }, {})
                    }

                    listResponseJson = {
                        ...listResponseJson,
                        ...result
                    };
                });
                return listResponseJson;
            }

            scope.compareClauseData = (changedVersion, lastELem, listResponseJson) => {
                if (!scope.isBaseTextComparision) {
                    if (changedVersion && scope['version' + changedVersion].documentFileId) {
                        if (changedVersion == 1) {
                            // Change left version
                            scope.compareDataToPost[compareDataToPostKeys[0]] = scope.version1.documentFileId;
                            scope.originalDocFileId = scope.version1.documentFileId;
                            scope.version1 = angular.copy(scope.allDocVersions.find(e => {
                                return e.documentFileId == scope.originalDocFileId
                            }));
                        } else if (scope.compareModeOnly && changedVersion == 2) {
                            // Change right version
                            scope.compareDataToPost[compareDataToPostKeys[1]] = scope.version2.documentFileId;
                            scope.newDocFileId = scope.version2.documentFileId;
                            scope.version2 = angular.copy(scope.allDocVersions.find(e => {
                                return e.documentFileId == scope.newDocFileId
                            }));
                        }
                    }
                    if(scope.compareModeOnly) {
                        if (JSON.stringify(scope.version2) == JSON.stringify(lastELem)) scope.showRevertBtn = true;
                        else scope.showRevertBtn = false;

                        if (scope.version1.documentFileId != null && scope.version1.documentFileId != scope.currentV1) {
                            scope.currentV1 = scope.version1.documentFileId;
                            _docVersions2 = scope.allDocVersions.filter(v => {
                                return v.documentFileId != scope.version1.documentFileId
                            });
                            scope.docVersions2 = angular.copy(_docVersions2);
                        }
                    }
                    if (scope.version2.documentFileId != null && scope.version2.documentFileId != scope.currentV2) {
                        scope.currentV2 = scope.version2.documentFileId;
                        _docVersions1 = scope.allDocVersions.filter(v => {
                            return scope.compareModeOnly ? v.documentFileId != scope.version2.documentFileId : (v.version < scope.version2.version)
                        });
                        scope.docVersions1 = angular.copy(_docVersions1);
                        updateDocVerArrForCompareWithDD();
                        if (scope.baseTextComparision) {
                            scope.docVersions1.push({versionLabel: intl_msg[30189], version: 'baseText'})
                        } else {
                            scope.compareDataToPost[compareDataToPostKeys[0]] = scope.version1.documentFileId;
                        }
                    }

                    // Populate sourceDocumentFileId from listData call's item if it's empty.
                    if(scope.compareDataToPost[compareDataToPostKeys[0]] == null) {
                        scope.compareDataToPost[compareDataToPostKeys[0]] = scope.version1.documentFileId;
                    }

                    if(!scope.myModelInstance && !scope.clauseCategoryId && !scope.groupId && !scope.compareModeOnly) {
                        return;
                    }

                    scope.compareDataToPost['categoryId'] = scope.clauseCategoryId;
                    scope.compareDataToPost['groupId'] = scope.groupId;
                    const makeCompareCall = scope.compareModeOnly || changedVersion == 1;
                    // Populate compare window version comparison
                    const reqUrl = (scope.compareModeOnly) ? '/tblclause/getCompareData' : makeCompareCall ? '/tblcdr/deviation/v1/clause/compare' : '/tblcdr/category/text';
                    const analyticsStatsScope = $('[cdr-analytic-stats]').scope();
                    const dataToPost = makeCompareCall ? scope.compareDataToPost : {...scope.compareDataToPost, documentFileId : scope.compareDataToPost.compareDocumentFileiId, deviationReference: analyticsStatsScope?.deviationReference?.id}
                    startLoader();
                    return http({
                        method: 'POST',
                        url: reqUrl,
                        data: dataToPost
                    }).then(function (response) {
                        if(response.status !== 200){
                            console.error('Error:' + response );
                            stopLoader();
                            return false;
                        }
                        scope.clauseDeviationScoreInfo = {
                            ae: response.data.aeDeviationScore,
                            word: response.data.wordDeviationScore,
                            deviationSummary: response.data.deviationSummary,
                            deviationSeverity:  response.data.deviationSeverity?.name ? response.data.deviationSeverity.id : response.data.deviationSeverityIdName?.id,
                            deviationSeverityName: response.data.deviationSeverity?.name || response.data.deviationSeverityIdName?.name
                        }
                        scope.isSummaryPresent = false;
                        if (response.data.scoreFeatureVersion)
                            scope.scoreFeatureVersion = response.data.scoreFeatureVersion;
                        if (response.data.deviationSummary){
                            scope.isSummaryPresent = true;
                            // if(response.data.deviationSummary.length > 400) {
                            //     scope.showReadMoreToggle = true;
                            // }
                        }
                        scope.uniqueClauseIds = [];
                        scope.combinedOriginalText = '';
                        scope.combinedOriginalHtml = '';
                        scope.combinedNewText = '';
                        scope.combinedNewlHtml = '';
                        if(makeCompareCall) {
                            scope.clauseCompareInfo = response.data.clauseInfo;
                            if(!scope.clauseCompareInfo[scope.originalDocFileId] || !scope.clauseCompareInfo[scope.newDocFileId]){
                                stopLoader();
                                Toaster.create(intl_msg[23673]);
                            }
        
                            // Compare documents
                            scope.original = scope.clauseCompareInfo[scope.originalDocFileId] || [];
                            scope.new = scope.clauseCompareInfo[scope.newDocFileId] || [];

                            if (scope.compareModeOnly) {
                                // Coverted data for compare from show page
                                scope.original = [scope.original];
                                scope.new = [scope.new];
                            }
                            if(scope.original && scope.original.find(obj => obj.intermediateVersion)){
                                scope.intermediateVersion = scope.originalDocFileId;
                            } else if (scope.new && scope.new.find(obj => obj.intermediateVersion)){
                                scope.intermediateVersion = scope.newDocFileId;
                            }
                            

                            scope.new = scope.new.map(obj => {
                                if(scope.compareModeOnly) {
                                    scope.combinedNewText = scope.combinedNewText + obj.text + (scope.new.length > 1 ? '<hr class="clause-sep">' : '');
                                    scope.combinedNewlHtml = scope.combinedNewlHtml + obj.htmlText + (scope.new.length > 1 ? '<hr class="clause-sep">' : '');
                                }
                                if(!scope.uniqueClauseIds.includes(obj.contentControlId)) scope.uniqueClauseIds.push(obj.contentControlId);
                                return {
                                    ...obj,
                                    ...listResponseJson ? listResponseJson[obj.contentControlId] : {},
                                    ...(!scope.compareModeOnly && scope.newJSON && scope.newJSON[obj.contentControlId] ? 
                                        {'intermediateVersion': scope.newJSON[obj.contentControlId]['intermediateVersion'],
                                            'draftSavedDuration': scope.newJSON[obj.contentControlId]['draftSavedDuration']} :
                                        {'intermediateVersion': obj['intermediateVersion'],'draftSavedDuration': obj['draftSavedDuration']}
                                    )
                                }
                            });

                            scope.original && scope.original.map(obj => {
                                scope.combinedOriginalText = scope.combinedOriginalText + obj.text + (scope.original.length > 1 ? '<hr class="clause-sep">' : '');
                                scope.combinedOriginalHtml = scope.combinedOriginalHtml + obj.htmlText + (scope.original.length > 1 ? '<hr class="clause-sep">' : '');
                                if(!scope.uniqueClauseIds.includes(obj.contentControlId)) scope.uniqueClauseIds.push(obj.contentControlId);
                            });
                            scope.originalJSON = _.keyBy(scope.original, 'contentControlId')
                            scope.newJSON = _.keyBy(scope.new, 'contentControlId');

                            if (response.data.compare) {
                                if(!scope.compareModeOnly) {
                                    scope.html.diff = {};
                                    scope.text.diff = {};
                                    scope.uniqueClauseIds.forEach(contentControlId => {
                                        scope.html.diff[contentControlId] = htmldiff(scope.originalJSON[contentControlId]?.htmlText || '', scope.newJSON[contentControlId]?.htmlText || '');
                                        scope.text.diff[contentControlId] = htmldiff(scope.originalJSON[contentControlId]?.text || '', scope.newJSON[contentControlId]?.text || '');
                                    });
                                } else {
                                    scope.html.diff = htmldiff(scope.combinedOriginalHtml, scope.combinedNewlHtml);
                                    scope.text.diff = htmldiff(scope.combinedOriginalText, scope.combinedNewText);
                                }
                            }else{
                                scope.text.diff = scope.html.diff = "No text changes found";
                            }
                            if(scope.selectedClauseId) {
                                const originalHTMLText = (scope.original ? scope.original[scope.selectedClauseId]?.htmlText : '');
                                scope.selectedClauseHTMLDiff = htmldiff( originalHTMLText || '', scope.newJSON[scope.selectedClauseId]?.htmlText || '');
                            }

                            timeout(() => {
                                let tds = $('#diffVersion').find('td');
                                if (tds && tds.length) {
                                    for (const element of tds) {
                                        if (!$(element).text())
                                            $(element).remove();
                                    }
                                }
                            })

                            if (!changedVersion) {
                                scope.html.parent = angular.copy(scope.html.new);
                            }
                        } else {
                            transformDataFromCategoryResponse(response, listResponseJson);
                            timeout(() => {
                                let tds = $('#diffVersion').find('td');
                                if (tds && tds.length) {
                                    for (const element of tds) {
                                        if (!$(element).text())
                                            $(element).remove();
                                    }
                                }
                            })
                        }
                        stopLoader();

                    }, function errorCallback(error) {
                        console.error('Data cannot be loaded due to: ' + error);
                    });

                } else {
                    scope.compareBaseTextVersion(changedVersion, listResponseJson);
                }
            }

            scope.onEditClause = async (clauseId) => {
                scope.selectedClauseId = clauseId;
                // if left section is not selected till now and edit is clicked then set data for left section
                // if(!_.get(scope.version1, 'documentFileId')) {
                //     scope.version1 = angular.copy(scope.allDocVersions.find(e => {
                //         return e.documentFileId == scope.originalDocFileId
                //     }));
                //     scope.currentV1 = scope.version1.documentFileId;
                //     await scope.compareDocVersions(1);
                // }
                scope.version1 = {};
                scope.selectedComparisonType = {};
                scope.viewCompareEdit = false;
                if(scope.reviewDataToPost) {
                    scope.editModeActive = true;
                    scope.reviewDataToPost.contentControlId = scope.newJSON[clauseId]?.contentControlId;
                    fetchReviewClauseText().then(() => scope.changeView(true));
                }
                const originalHTMLText = (scope.original ? scope.original[clauseId]?.htmlText : '');
                scope.selectedClauseHTMLDiff = htmldiff(originalHTMLText || '', scope.newJSON[clauseId]?.htmlText || '');
                scope.contentControlId = clauseId;
            }

            scope.compareBaseTextVersion = (changedVersion, listResponseJson) => {
                let reqUrl = "/tblcdr/deviation/v1/clause/base/compare",
                    dataToPost = angular.copy(scope.reviewDataToPost);
                dataToPost.documentFileId = parseInt(dataToPost.documentFileId);
                dataToPost.categoryId = parseInt(scope.clauseCategoryId);
                dataToPost.groupId = parseInt(scope.groupId);
                delete dataToPost.contentControlId;
                http({
                    method: 'POST',
                    url: reqUrl,
                    data: dataToPost
                }).then(function (response) {
                    if (response.status == 200) {
                        scope.clauseDeviationScoreInfo = {
                            ae: response.data.aeDeviationScore,
                            word: response.data.wordDeviationScore,
                            deviationSummary: response.data.deviationSummary,
                            deviationSeverity: response.data.deviationSeverityIdName?.id,
                            deviationSeverityName: response.data.deviationSeverityIdName?.name
                        }

                        // if (response.data.deviationSummary && response.data.deviationSummary.length > 400) {
                        //     scope.showReadMoreToggle = true;
                        // }

                        scope.isSummaryPresent = false;
                        if (response.data.scoreFeatureVersion)
                            scope.scoreFeatureVersion = response.data.scoreFeatureVersion;
                        if (response.data.deviationSummary){
                            scope.isSummaryPresent = true;
                            // if(response.data.deviationSummary.length > 400) {
                            //     scope.showReadMoreToggle = true;
                            // }
                        }

                        if (response.data.baseClauseText)
                            scope.scoreFeatureVersion = response.data.scoreFeatureVersion;

                        scope.original = response.data.baseClauseText || '';
                        scope.new = response.data.documentCCText || '';

                        scope.uniqueClauseIds = [];

                        if (scope.original && !scope.activeWindow.edit) {
                            scope.activeWindow.compare = true;
                        } else {
                            scope.activeWindow.compare = false;
                        }

                        scope.combinedOriginalText = '';
                        scope.combinedOriginalHtml = '';
                        scope.combinedNewText = '';
                        scope.combinedNewlHtml = '';

                        scope.original && scope.original.map(obj => {
                            scope.combinedOriginalText = scope.combinedOriginalText + obj.text + '<br>';
                            scope.combinedOriginalHtml = scope.combinedOriginalHtml + obj.htmlText + '<br>';
                        });

                        scope.new = scope.new.map(obj => {
                            scope.combinedNewText = scope.combinedNewText + obj.text + '<br>';
                            scope.combinedNewlHtml = scope.combinedNewlHtml + obj.htmlText + '<br>';
                            if(!scope.uniqueClauseIds.includes(obj.contentControlId)) scope.uniqueClauseIds.push(obj.contentControlId);

                            return {
                                ...obj,
                                ...listResponseJson ? listResponseJson[obj.contentControlId] : {},
                                ...(!scope.compareModeOnly && scope.newJSON && scope.newJSON[obj.contentControlId] ? 
                                    {'intermediateVersion': scope.newJSON[obj.contentControlId]['intermediateVersion'], 'draftSavedDuration': scope.newJSON[obj.contentControlId]['draftSavedDuration']} :
                                    {'intermediateVersion': obj['intermediateVersion'], 'draftSavedDuration': obj['draftSavedDuration']})
                            }
                        });

                        scope.originalJSON = _.keyBy(scope.original, 'contentControlId')
                        scope.newJSON = _.keyBy(scope.new, 'contentControlId');

                        if (scope.new?.find(obj => _.get(obj, 'reviewEditable') == 'false' && obj.intermediateVersion)) {
                            scope.intermediateVersion = scope.compareDocFileIds.compare;
                        }

                        if (response.data.compare) {
                            scope.html.diff = htmldiff(scope.combinedOriginalHtml, scope.combinedNewlHtml);
                            scope.text.diff = htmldiff(scope.combinedOriginalText, scope.combinedNewText);
                        }else{
                            scope.text.diff = scope.html.diff = "No text changes found";
                        }

                        if(scope.selectedClauseId) {
                            const originalHTMLText = (scope.original ? scope.original[0]?.htmlText : '');
                            scope.selectedClauseHTMLDiff = htmldiff( originalHTMLText || '', scope.newJSON[scope.selectedClauseId]?.htmlText || '');
                        }

                        timeout(() => {
                            let tds = $('#diffVersion').find('td');
                            if (tds && tds.length) {
                                for (const element of tds) {
                                    if (!$(element).text() || !$(element).text().trim())
                                        $(element).remove();
                                }
                            }
                        })

                        if (!changedVersion) {
                            scope.html.parent = angular.copy(scope.html.new);
                        }
                    }
                    stopLoader();

                }, function errorCallback(error) {
                    console.error('Data cannot be loaded due to: ' + error);
                });
            }

            const updateDocVerArrForCompareWithDD = () => {
                if(!scope.compareModeOnly) {
                    scope.docVersions1 = !scope.docVersions1 ? [] : scope.docVersions1;
                    scope.allDocVersions = !scope.allDocVersions ? [] : scope.allDocVersions;
                }
            }

            const fetchReviewClauseText = () => {
                // Call to load review View HTML
                return http({
                    method: 'POST',
                    url: '/tblcdr/review/clauseText',
                    data: scope.reviewDataToPost
                }).then(function (response) {
                    const mapTagsToOptionsData = (data) => {
                        angular.forEach(data.inlineTags, function (obj) {
                            if (_.has(data.clauseTagsOptionData, obj.tagId)) {
                                obj['optionsData'] = data.clauseTagsOptionData[obj.tagId];
                            }
                        });
                    }
                    if (response.data) {
                        scope.htmlContent.reviewWindow = (!!response.data.reviewClauseText) ? htmldiff(response.data.originalClauseText, response.data.reviewClauseText) : response.data.originalClauseText;
                        scope.htmlContent.editWindow = (!!response.data.reviewClauseText) ? '<span>'+response.data.reviewClauseText+'</span>' : '<span>'+response.data.originalClauseText+'</span>';
                        scope.reviewContent.initial.inlineTagsCopy = angular.copy(response.data.inlineTags);
                        scope.baseTextComparision = response.data.baseTextComparison;
                        updateDocVerArrForCompareWithDD();
                        if (scope.baseTextComparision && scope.docVersions1 && (scope.allDocVersions.length > 1 || !scope.compareModeOnly) && !_.find(scope.docVersions1, ['versionLabel', intl_msg[30189]])) {
                            scope.docVersions1.push({versionLabel: intl_msg[30189], version: 'baseText'})
                            scope.isBaseTextButton = true;
                        }
                        mapTagsToOptionsData(response.data);
                        scope.reviewContent.initial.inlineTags = response.data.inlineTags;
                        if(scope.baseTextComparision && scope.compareModeOnly && !scope.docVersions1) {
                            scope.isBaseTextComparision = true;
                            !scope.editModeActive && scope.changeViewBaseText();
                        }else if(scope.baseTextComparision && scope.compareModeOnly && _.get(scope.docVersions1,"length") == 1){
                            scope.isBaseTextComparision = true;
                        }
                    }

                    if (scope.reviewTaskDetail && scope.reviewTaskDetail.value && scope.reviewTaskDetail.value.currentTask) {
                        scope.actionButtons = scope.reviewTaskDetail.value.currentTask.nextTaskIds;
                    }

                    scope.tagsInContentArray = [];
                    scope.tagsInContent = $(scope.htmlContent.editWindow).length && $(scope.htmlContent.editWindow).find('[data-id*="-aw-sdt-tag"]');
                    scope.tagsInContent.map((i, e) => {
                        scope.tagsInContentArray.push($(e).attr('data-id').split('-aw-sdt-tag:')[1].split(';')[0].slice(1, -1));
                    });
                    if(response.data && !scope.editModeActive && !scope.compareModeOnly) {
                        scope.changeView(false);
                    }
                }, function errorCallback(error) {
                    console.error('Data cannot be loaded due to: ' + error);
                });
            }

            const transformDataFromCategoryResponse = (response, listResponseJson) => {
                scope.uniqueClauseIds = [];
                response.data.instances = _.sortBy(response.data.instances.map(obj => {
                    return {
                        ...obj,
                        ...listResponseJson ? listResponseJson[obj.contentControlId] : {},
                    };
                }), [(o) => o.sortOrder]);
                scope.compareModifiedBy = response.data.modifiedBy;
                if (response.data.instances.find(obj => _.get(obj, 'reviewEditable') == 'false' && obj.intermediateVersion)){
                    scope.intermediateVersion = scope.newDocFileId;
                }
                scope.newJSON = _.keyBy(response.data.instances, 'contentControlId');
                response.data.instances.forEach(obj => {
                    if(!scope.uniqueClauseIds.includes(obj.contentControlId)) scope.uniqueClauseIds.push(obj.contentControlId);
                });

                if (response.data.baseClauseText) {
                    scope.original = response.data.baseClauseText || '';

                    scope.combinedOriginalHtml = '';

                    scope.original && scope.original.map(obj => {
                        scope.combinedOriginalHtml = scope.combinedOriginalHtml + obj.htmlText + '<br>';
                    });
                }
            }

            // If Modal is opened in Compare only mode
            if (scope.compareModeOnly) {
                compareDataToPostKeys = ['versionFrom', 'versionTo'];
                scope.compareDataToPost = {
                    versionFrom: scope.compareDocFileIds.source,
                    versionTo: scope.compareDocFileIds.compare
                }
                scope.trustAsHtml = (string) => {
                    return sce.trustAsHtml(string);
                }
                scope.activateCompareView();
                stopLoader();
            }
            // If modal is opened the older way with(multiple cases within like: review, edit & compare modes)
            else {
                // Setup settings obj for ng-dropdown-autocomplete
                filterService.setMsSettings.call(scope);
                fetchReviewClauseText();

                var convertValToDate = function(tag) {
                    scope.fallbackDateFormat = SirionUtils.getActualDateFormat();
                    const tagDateFormat = tag?.dateFormat?.replace(/d/g, "D").replace(/y/g, "Y");
                    const dateFormat = tagDateFormat || scope.fallbackDateFormat;
                    const date = !tag.value || !dateFormat ? tag.value : moment(tag.value, dateFormat).toDate();
                    tag.displayValue = date;
                    return tag.displayValue;
                };

                var mapDisplayValueInlineReviewDateTags = (data) => {
                    if(data && typeof(data) == 'object') {
                        data?.forEach(tag =>  {
                            if(tag?.type == 8) {
                                convertValToDate(tag);
                            }
                        });
                        
                    }
                }

                scope.getAutocompleteUrl = (optionsData) => {
                    const autoCompleteDropDownId = optionsData.autoCompleteDropDownId;
                    const entityFieldId = optionsData.entityFieldId;
                    const entityTypeId = scope.data.entityTypeId.values;
                    const url = appName + "/options/" + autoCompleteDropDownId + "?pageType=6" + "&entityTpeId=" + entityTypeId + "&fieldId=" + entityFieldId;
                    return url;
                }

                scope.getSettings = (id) => {
                    scope.mssettings.selectionLimit = (id == 3) ? 1 : 0;
                    return scope.mssettings;
                }

                function initDatePickerOnTextField() {
                    if (angular.element(".wizardDateField").length > 0) {
                        angular.element(".wizardDateField").each(function (i, elem) {
                            if ($(elem).attr("data-tag-type") == 8) {
                                var tagId = angular.element(elem).attr("data-id");
                                SirionUtils.setUpCommonPicker.call(scope, "tag_" + tagId, null, null, null, true);
                            }
                        });
                    }
                }

                scope.openConfirmation = (id, fromRestore = false) => {
                    const contentControlId = id ? id : scope.contentControlId;
                    if(!scope.revertedVersion[contentControlId] && scope.newJSON[contentControlId]['intermediateVersion']) {
                        const args = {
                            popupType: 'confirm',
                            str: 'Reverting will discard all the changes made in the current version. Do you want to proceed?',
                            heading: 'Confirmation',
                            yesCbFn: () => {
                                scope.revertVersion(id, fromRestore);
                            },
                            yesName: 'Revert to Previous Version',
                            noCbFn: () => {
                            },
                            noName: 'Cancel'
                        }
                        window.SirionUtils.openSirionDialogs(args)
                    } else {
                        scope.revertVersion(id, fromRestore);
                    }
                }

                scope.revertVersion = (id, fromRestore = false) => {
                    startLoader();
                    let contentControlId = id ? id : scope.contentControlId;
                    let dataToPost = {
                        contentControlId,
                        "documentFileId": scope.docFileSelectedId,
                        "revertVersion": !scope.revertedVersion[contentControlId]
                    }
                    http({
                        method: 'POST',
                        url: '/tblcdr/review/performTask',
                        data: dataToPost
                    }).then(function (response) {
                        scope.revertedVersion[contentControlId] = !scope.revertedVersion[contentControlId];
                        if (fromRestore) Toaster.create(scope.revertedVersion[contentControlId] ? 'Clause has been successfully removed' : 'Clause has been successfully restored')
                        scope.setRevertView(true, contentControlId);
                        // stopLoader();
                    }, function errorCallback(error) {
                        stopLoader();
                        console.error('Data cannot be loaded due to: ' + error);
                    });
                }

                scope.setRevertView = (fromRevertBtn, id) => {

                    // let lastELem = scope.clonedCompareDocsData ? scope.clonedCompareDocsData[scope.clonedCompareDocsData.length - 1] : "";

                    if (scope.revertedVersion[id]) {
                        // scope.isRevertClicked = true;
                        
                        if(fromRevertBtn) Toaster.create(`Clause text successfully reverted to the previous version. Changes will be visible once review process is completed.`, {iconClass: "icon-Tick-Selected"});
                    } else if(fromRevertBtn) Toaster.create('Clause version restored successfully.', {iconClass: "icon-Tick-Selected"});

                    scope.version2 && scope.prevCompareVerChange(scope.version2.documentFileId);
                }

                const initializeTags = () => {
                    if(_.get(scope.reviewContent, 'initial.inlineTags')) mapDisplayValueInlineReviewDateTags(scope.reviewContent.initial.inlineTags);
                    setTimeout(() => {
                        initDatePickerOnTextField();
                    }, 500);
                }

                const updateEditorText = () => {
                    window.editor.editor.setData(scope.htmlContent.editWindow);
                }

                const initializeEditMode = () => {
                    mountCkEditor('#iframe_textEditor_clause_content', scope.htmlContent.editWindow);
                    initializeTags();
                    const setInitialDataForEditor = setInterval(() => {
                        if (window?.editor?.editor) {
                            scope.reviewContent.initial.html = window?.editor?.editor.getData();
                            clearInterval(setInitialDataForEditor);
                        }
                    }, 100);
                }

                scope.resetTab = () => {
                    scope.selectedDeviationTabIndex = 1;
                    scope.combinedOriginalHtml = '';
                    scope.selectedComparisonType = scope.comparisonTypes[0];
                    // scope.clauseDeviationScoreInfo = {}
                }

                scope.changeView = (type) => {
                    startLoader();
                    scope.isNewCommentsBoxVisible = false;
                    if (type) {
                        scope.activeWindow.compare=false;
                        scope.activeWindow.edit = true;
                        if(_.get(scope.reviewContent, 'initial.inlineTags')) mapDisplayValueInlineReviewDateTags(scope.reviewContent.initial.inlineTags);
                        scope.$$postDigest(() => {
                            initializeEditMode();
                            stopLoader();
                        });
                        timeout(function () {
                            initDatePickerOnTextField();
                        }, 2000);
                    } else {
                        scope.contentControlId = null;
                        if(!scope.compareModeOnly) {
                            scope.version1 = {};
                            scope.selectedComparisonType = {};
                            scope.versionDiffComparisonWindow = false;
                        }
                        // Here original version is the left version
                        if ((scope.original && scope.original?.length > 0) || !scope.new) {
                            scope.activeWindow.compare = true;
                        }
                        scope.activeWindow.edit = false;
                        scope.selectedClauseId = null;
                        scope.toggleCompareOptions(false);
                        scope.activateCompareView();
                    }
                    scope.editModeActive = false;
                    scope.resetTab();
                }

                scope.closeViewCompare=()=>{
                    scope.viewCompareEdit = false;
                    scope.version1 = {};
                    scope.selectedComparisonType = {};
                }
                scope.changeViewBaseText = () => {
                    startLoader();
                    scope.activeWindow.compare = true;
                    scope.activateCompareView();
                }

                scope.closeDatepicker = function (tag) {
                    const id = tag.id;
                    if(tag.displayValue && typeof(tag.displayValue) == 'string') { tag.value = tag.displayValue; }
                    var el = $("[data-id=" + id + "]");
                    if (el.length) {
                        el.trigger('blur');
                    }
                }

                scope.clickDatepicker = function (e) {
                    e.stopPropagation();
                    var id = $(e.target).attr('data-id');
                    scope.commonDatepicker.opened = {};
                    scope.commonDatepicker.opened["tag_" + id] = !scope.commonDatepicker.opened["tag_" + id];
                }

                scope.getFieldType = function (fieldId) {
                    switch (fieldId) {
                        case 1:
                            return 'text';
                        case 8:
                            return 'date';
                    }
                }

                scope.cancelCompareWindow = () => {
                    if(scope.isBaseTextButton) {
                        scope.isBaseTextComparision = false;
                        scope.isBaseTextButton=false;
                    }else{
                        scope.clauseDeviationScoreInfo = {};
                        scope.activeWindow.compare = false;
                    }
                }

                scope.openNewCommentsCard = () => {
                    scope.isNewCommentsBoxVisible = true;
                    scope.enableCommentAddition = false;
                }

                scope.addNewComment = () => {
                    // Hit add Comment API

                    // After successful addition
                    scope.isNewCommentsBoxVisible = false;
                    scope.enableCommentAddition = false;
                }

                scope.cancelCommentOperation = (e) => {
                    angular.element(e.target).closest('#jx-commentForm').find('.jx-fileListDiv').html('');
                    scope.isNewCommentsBoxVisible = false;
                    scope.enableCommentAddition = false;
                }

            }

            

            if(rootScope.compareWindowOnly && !scope.editModeActive) {
                setTimeout(() => {
                    scope.changeView(false);
                },0)
            } else if(scope.editModeActive){
                scope.compareData?.length && scope.activateCompareView();
                scope.changeView(true);
            }
        }
    }
}]);
